import {get, post} from '../utils/api'
import http from '../utils/api'

export const FETCH_USER_BEGIN = 'FETCH_USER_BEGIN';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const LOGOUT_USER_BEGIN = 'LOGOUT_USER_BEGIN';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

export const FETCH_USER_ROLES_BEGIN = 'FETCH_USER_ROLES_BEGIN';
export const FETCH_USER_ROLES_SUCCESS = 'FETCH_USER_ROLES_SUCCESS';

export const UPDATE_USER_BEGIN = 'UPDATE_USER_BEGIN';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const UPDATE_USER_TO_INACTIVE_BEGIN = 'UPDATE_USER_TO_INACTIVE_BEGIN';
export const UPDATE_USER_TO_INACTIVE_SUCCESS = 'UPDATE_USER_TO_INACTIVE_SUCCESS';
export const UPDATE_USER_TO_INACTIVE = 'UPDATE_USER_TO_INACTIVE';

export const fetchUserBegin = () => ({
    type: FETCH_USER_BEGIN
});

export const fetchUserSuccess = (result) => ({
    type: FETCH_USER_SUCCESS,
    payload: result
});
export const logoutUserBegin = () => ({
    type: LOGOUT_USER_BEGIN
});

export const logoutUserSuccess = (result) => ({
    type: LOGOUT_USER_SUCCESS
});

export const fetchUserRolesBegin = () => ({
    type: FETCH_USER_ROLES_BEGIN
});

export const fetchUserRolesSuccess = (result) => ({
    type: FETCH_USER_ROLES_SUCCESS,
    payload: result
});

export const UpdateUserBegin = () => ({
    type: UPDATE_USER_BEGIN
});

export const UpdateUserSuccess = result => ({
    type: UPDATE_USER_SUCCESS,
    payload: result
});
export const UpdateUserFailure = () => ({
    type:  UPDATE_USER_FAILURE,
});
export const setUserToInActiveBegin= () => ({
    type:  UPDATE_USER_TO_INACTIVE_BEGIN,
});
export const setUserToInActiveSuccess = () => ({
    type:  UPDATE_USER_TO_INACTIVE_SUCCESS,
});

export function fetchUser() {
    return dispatch => {
        dispatch(fetchUserBegin());
        return get('/user').then((res) => {
            dispatch(fetchUserSuccess(res));
        });
    };
};

export function logoutUser() {
    return dispatch => {
        dispatch(logoutUserBegin());
        return http.post('logout').then((res) => {
            dispatch(logoutUserSuccess(res));

        });
    };
}
export function fetchUserRoles() {
    return dispatch => {
        dispatch(fetchUserRolesBegin());
        return get('users/manage').then((res) => {
            dispatch(fetchUserRolesSuccess(res));
        });
    };
};
export function updateUser(data, uid) {
    return dispatch => {
        dispatch(UpdateUserBegin());
        return post('user/' + uid, data)
            .then((res) => {
                dispatch(UpdateUserSuccess(res));
            }).then(function (res) {
                dispatch(fetchUserRoles());
            }).catch(err => {
                dispatch(UpdateUserFailure());
            });
    };
}
export function setUserToInActive(uid) {
    return dispatch => {
        dispatch(setUserToInActiveBegin());
        return http.delete('user/' + uid)
            .then((res) => {
                dispatch(setUserToInActiveSuccess());
            }).then(function (res) {
                dispatch(fetchUserRoles());
            }).catch(err => {

            });
    };
}
